import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import AuthNavbar from "components/Navbars/AuthNavbar.js";
import Footer from "components/Footer/Footer.js";

import bgImagem from "../../assets/img/background.png";

import routes from "../../routes/auth";

class Pages extends React.Component {
  getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = this.getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.pathname.indexOf(
            routes[i].layout + routes[i].path
          ) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  getFullPageName = (routes) => {
    let pageName = this.getActiveRoute(routes);
    switch (pageName) {
      case "Login":
      case "Esqueci minha senha":
      case "Redefinir senha":
        return "login-page";
      case "Register":
        return "register-page";
      default:
        return "Default Brand Text";
    }
  };
  componentDidMount() {
    document.documentElement.classList.remove("nav-open");
  }
  render() {
    return (
      <>
        <AuthNavbar brandText="TMS" />
        <div className="wrapper wrapper-full-page" ref="fullPages">
          <div
            className={"full-page " + this.getFullPageName(routes)}
            style={{
              backgroundImage: `url(${bgImagem})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              // Sem `backgroundAttachment: fixed`: com fixed + cover o fundo é
              // dimensionado pelo viewport, então em páginas mais altas que a
              // tela (ex.: registro com formulário longo) a parte de baixo fica
              // sem fundo ("quebra" no rodapé). Sem fixed, o cover cobre toda a
              // altura do .full-page.
              minHeight: "100vh",
            }}
          >
            <Switch>
              {this.getRoutes(routes)}
              {/* PO1-3391 (P3): preserva o ?next= ao cair no login. */}
              <Redirect
                from="*"
                to={{ pathname: "/auth/login", search: (this.props.location && this.props.location.search) || "" }}
              />
            </Switch>
            <Footer fluid />
          </div>
        </div>
      </>
    );
  }
}

export default Pages;
